var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-container',{staticStyle:{"height":"100%"}},[_c('el-header',[_c('h3',{staticStyle:{"color":"#3a3a3a"}},[_vm._v("g0v Hacking Map "),_c('sub',[_c('i',[_vm._v("Beta")])])])]),_vm._v(" "),_c('el-container',[_c('el-aside',[_c('TheList')],1),_vm._v(" "),_c('el-main',[_c('TheMap')],1)],1),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.isEditing,"show-close":false}},[_c('ProjectEditor')],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fbfd1e60","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 698
// module chunks = 0